import React, { useState, useEffect } from "react";
import CustomerTable from "Pages/AdminInterface/clients/client/endcustomers/components/CustomerTable";
import { CreateEndCustomer } from "Pages/AdminInterface/endcustomers/CreateEndCustomer";
import { Dialog } from "@mui/material";
import { ClientsContextProvider } from "Context/Clients";
import { useEndCustomers } from "Context/EndCustomers";

export default function MyPageEndcustomer({ client }) {
  const [createEndCustomerModalOpen, setCreateEndCustomerModalOpen] =
    useState(false);

  const { endCustomers, fetchEndCustomers } = useEndCustomers();

  useEffect(() => {
    fetchEndCustomers();
  }, []);

  return (
    <>
      <CustomerTable
        customers={endCustomers}
        openCreateEndcustomer={() => setCreateEndCustomerModalOpen(true)}
      />
      <Dialog
        open={createEndCustomerModalOpen}
        PaperProps={{
          style: {
            backgroundColor: "transparent",
            boxShadow: "none",
          },
        }}
      >
        <ClientsContextProvider>
          <CreateEndCustomer
            endcustomers={endCustomers}
            onClose={() => {
              setCreateEndCustomerModalOpen(false);
              fetchEndCustomers();
            }}
          />
        </ClientsContextProvider>
      </Dialog>
    </>
  );
}
